import { FC } from 'react'

import { cn } from '../../../utils/cn'

interface InputErrorMessageProps {
  className?: string
  id?: string
  error?: {
    message?: string
  }
}

export const InputErrorMessage: FC<InputErrorMessageProps> = ({
  error,
  className,
  id
}) => {
  if (!error?.message) {
    return null
  }

  return (
    <p
      id={id}
      className={cn('text-left text-sm text-red-700', className)}
      role="alert">
      {error.message}
    </p>
  )
}
